import { useState } from 'react';
import { EMPTY_ADD_TO_CART_SELECTION } from '../add-to-cart-drawer.const';
import { AddToCartSelection } from '../add-to-cart-drawer.types';

// Resets the drawer when the drawer is opened.
// Needs to happen on open, not on close, to ensure smooth animations
export const useResetAddToCartDrawer = (
    isOpen: boolean,
    setSelection: (selection: AddToCartSelection) => void,
    clearAddToCartError: () => void
) => {
    const [prevIsOpen, setPrevIsOpen] = useState(isOpen);
    if (isOpen !== prevIsOpen) {
        setPrevIsOpen(isOpen);
        if (isOpen) {
            setSelection(EMPTY_ADD_TO_CART_SELECTION);
            clearAddToCartError();
        }
    }
};
